import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";
import { Tabs } from "@mui/base/Tabs";
import { TabsList as BaseTabsList } from "@mui/base/TabsList";
import { TabPanel as BaseTabPanel } from "@mui/base/TabPanel";
import { buttonClasses } from "@mui/base/Button";
import { Tab as BaseTab, tabClasses } from "@mui/base/Tab";
import { Box, TextField, Typography, Grid } from "@mui/material";
import { allCountriesList } from "../../../Api/CountriesAllList";
import { FcCheckmark } from "react-icons/fc";
import { useSelector } from "react-redux";
import {
  a100,
  a114,
  a115,
  a95,
  a96,
  a97,
  a98,
  a99,
} from "../../../Api/RootApiPath";

export default function AdminFirstLogin({ currentStep }) {
  const [step, setStep] = useState(1);
  const [isOpen, setIsOpen] = useState(false);

  const [newCompany, setNewCompany] = useState({
    ClientCode: "",
    CompCode: "",
    CompName: "",
    CompShortName: "",
    CompOwnerName: "",
    CompRegisteredAddress: "",
    CompFactoryAddress: "",
    CompMobileNo: "",
    CompPhoneNo: "",
    CompRegistrationNo: "",
    CompYearOfEstablishment: "",
    CompEmail: "",
    CompGSTINNo: "",
    CompPanNo: "",
    CompAddharNo: "",
    CompLogo: "",
    CompWebsite: "",
    CompVATNo: "",
    CompCGSTNo: "",
    CompStatus: "",
    Town: "",
    Country: "",
    State: "",
    City: "",
    FinancialYear: "",
    BaseCurrency: "",
    TransactionSeries: "",
    CompLoginStatus: "",
    OldEntry: false,
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);

  const [newBranch, setNewBranch] = useState({
    BranchCode: "",
    CompId: "",
    BranchName: "",
    BranchType: "",
    BranchHead: "",
    BranchAddress: "",
    PhoneNumber: "",
    MobileNumber: "",
    FaxNumber: "",
    Country: "",
    Town: "",
    State: "",
    City: "",
    PostalCode: "",
    GSTIN: "",
    BranchEmailId: "",
    BranchStatus: "",
    FinancialYear: "",
    BranchLoginStatus: "",
    OldEntry: false,
  });
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [newBank, setNewBank] = useState({
    BankName: "",
    AccountName: "",
    BankAccountNo: "",
    BranchName: "",
    MobileNumber: "",
    AccountType: "",
    BranchAddress: "",
    IfscCode: "",

    OldEntry: false,
  });
  const toggleOpen = () => setIsOpen(!isOpen);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  useEffect(() => {
    setStep(currentStep);
  }, [currentStep]);

  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCompanies();
  }, []);

  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllBranches();
  }, []);
  const addCompany = async (e) => {
    e.preventDefault();

    let formData = new FormData();

    formData.append("ClientCode", clientCode);
    formData.append("CompName", newCompany.CompName);
    formData.append("CompShortName", newCompany.CompShortName);
    formData.append("CompOwnerName", newCompany.CompOwnerName);
    formData.append("CompRegisteredAddress", newCompany.CompRegisteredAddress);
    formData.append("CompFactoryAddress", newCompany.CompFactoryAddress);
    formData.append("CompMobileNo", newCompany.CompMobileNo);
    formData.append("CompPhoneNo", newCompany.CompPhoneNo);
    formData.append("CompRegistrationNo", newCompany.CompRegistrationNo);
    formData.append(
      "CompYearOfEstablishment",
      newCompany.CompYearOfEstablishment
    );
    formData.append("CompEmail", newCompany.CompEmail);
    formData.append("CompGSTINNo", newCompany.CompGSTINNo);
    formData.append("CompPanNo", newCompany.CompPanNo);
    formData.append("CompAddharNo", newCompany.CompAddharNo);
    formData.append("CompLogo", newCompany.CompLogo);
    formData.append("CompWebsite", newCompany.CompWebsite);
    formData.append("CompVATNo", newCompany.CompVATNo);
    formData.append("CompCGSTNo", newCompany.CompCGSTNo);
    formData.append("CompStatus", "Active");
    formData.append("Town", newCompany.Town);
    formData.append("Country", newCompany.Country);
    formData.append("State", newCompany.State);
    formData.append("City", newCompany.City);
    formData.append("FinancialYear", newCompany.FinancialYear);
    formData.append("BaseCurrency", newCompany.BaseCurrency);
    formData.append("TransactionSeries", newCompany.TransactionSeries);
    formData.append("CompLoginStatus", newCompany.CompLoginStatus || "Active");
    formData.append(
      "CompCode",
      newCompany.OldEntry ? newCompany.CompCode : "0"
    );
    formData.append("Id", newCompany.OldEntry ? newCompany.Id : "0");

    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }
    try {
      const response = await fetch(
        !newCompany.OldEntry ? a97 : a96,
        // a96,
        {
          method: "POST",
          // headers: {
          //   "Content-Type": "application/json",
          // },
          body: formData,
        }
      );
      const data = await response.json();

      const updatedCompany = {
        ...data,
        OldEntry: true,
      };

      setNewCompany(updatedCompany);
      console.log(data);
      console.log(updatedCompany, "updatedCompany");
      setStep(step + 1);
      fetchAllCompanies();
    } catch (error) {
      console.error(error);
    }
  };

  const addBranch = async (e) => {
    e.preventDefault();

    const formData = {
      BranchCode: newBranch.BranchCode,
      ClientCode: clientCode,
      CompId: newBranch.CompId,
      BranchName: newBranch.BranchName,
      BranchType: newBranch.BranchType,
      BranchHead: newBranch.BranchHead,
      BranchAddress: newBranch.BranchAddress,
      PhoneNumber: newBranch.PhoneNumber,
      MobileNumber: newBranch.MobileNumber,
      FaxNumber: newBranch.FaxNumber,
      Country: newBranch.Country,
      Town: newBranch.Town,
      State: newBranch.State,
      City: newBranch.City,
      PostalCode: newBranch.PostalCode,
      GSTIN: newBranch.GSTIN,
      BranchEmailId: newBranch.BranchEmailId,
      BranchStatus: "Active",
      FinancialYear: newBranch.FinancialYear,
      BranchLoginStatus: "Active",
      ...(newBranch.OldEntry ? { Id: newBranch.Id } : {}),
    };
    console.log(formData, "formData to send");
    try {
      const response = await fetch(
        !newBranch.OldEntry ? a100 : a99,
        // a96,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      const updatedBranch = {
        ...data,
        OldEntry: true,
      };

      setNewBranch(updatedBranch);
      console.log(data);
      console.log(updatedBranch, "updatedBranch");
      setStep(step + 1);
    } catch (error) {
      console.error(error);
    }
  };

  const addBank = async (e) => {
    e.preventDefault();

    const formData = {
      ClientCode: clientCode,
      BankName: newBank.BankName,
      AccountName: newBank.AccountName,
      BankAccountNo: newBank.BankAccountNo,
      BranchName: newBank.BranchName,
      MobileNumber: newBank.MobileNumber,
      AccountType: newBank.AccountType,
      BranchAddress: newBank.BranchAddress,
      IfscCode: newBank.IfscCode,
      ...(newBank.OldEntry ? { Id: newBank.Id } : {}),
    };
    console.log(formData, "formData to send");
    try {
      const response = await fetch(
        !newBank.OldEntry ? a115 : a114,
        // a96,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      const updatedBank = {
        ...data,
        OldEntry: true,
      };

      setNewBank(updatedBank);
      console.log(data);
      console.log(updatedBank, "updatedBank");
      setStep(step + 1);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleNewCompanyChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setNewCompany({ ...newCompany, [name]: value });
  };
  const handleNewBranchChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setNewBranch({ ...newBranch, [name]: value });
  };

  const handleNewBankChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setNewBank({ ...newBank, [name]: value });
  };
  return (
    <div style={{ width: "100%" }}>
      {step === 1 ? (
        <div className="adminFirstLoginInnerBox">
          <h4 style={{ textAlign: "left" }}>1. Add Company</h4>
          <form>
            <div>
              <label>
                Company Name <sup>*</sup>
              </label>
              <input
                type="text"
                name="CompName"
                value={newCompany.CompName}
                onChange={handleNewCompanyChange}
              />
            </div>
            <div>
              <label>
                Company Short Name <sup>*</sup>
              </label>
              <input
                type="text"
                name="CompShortName"
                value={newCompany.CompShortName}
                onChange={handleNewCompanyChange}
              />
            </div>
            <div>
              <label>
                Company Mobile No <sup>*</sup>
              </label>
              <input
                name="CompMobileNo"
                type="text"
                value={newCompany.CompMobileNo}
                onChange={handleNewCompanyChange}
              />
            </div>
            <div>
              <label>
                Town / Village <sup>*</sup>
              </label>
              <input
                name="Town"
                type="text"
                value={newCompany.Town}
                onChange={handleNewCompanyChange}
              />
            </div>
            <div>
              <label>
                City <sup>*</sup>
              </label>
              <input
                name="City"
                type="text"
                value={newCompany.City}
                onChange={handleNewCompanyChange}
              />
            </div>
            <div>
              <label>
                State <sup>*</sup>
              </label>
              <input
                name="State"
                type="text"
                value={newCompany.State}
                onChange={handleNewCompanyChange}
              />
            </div>
            <div>
              <label>
                Country <sup>*</sup>
              </label>
              <select
                name="Country"
                value={newCompany.Country}
                onChange={handleNewCompanyChange}
              >
                {allCountriesList.map((x, y) => (
                  <option key={y} value={x}>
                    {x}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label>
                Financial Year <sup>*</sup>
              </label>
              <input
                name="FinancialYear"
                type="text"
                value={newCompany.FinancialYear}
                onChange={handleNewCompanyChange}
              />
            </div>
            <div>
              <label>
                Base Currency <sup>*</sup>
              </label>
              <input
                name="BaseCurrency"
                type="text"
                value={newCompany.BaseCurrency}
                onChange={handleNewCompanyChange}
              />
            </div>
            <div>
              <label>
                Transaction Series <sup>*</sup>
              </label>
              <input
                type="text"
                name="TransactionSeries"
                value={newCompany.TransactionSeries}
                onChange={handleNewCompanyChange}
              />
            </div>
            {!isOpen ? (
              <div>
                <div
                  style={{ margin: "0px" }}
                  className="adminPanelLoginFormRegisterBox"
                >
                  <h5
                    style={{ margin: "0px" }}
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    Show All
                  </h5>
                </div>
                <button
                  type="button"
                  onClick={() => setStep(step + 1)}
                  style={{ marginInline: "0px" }}
                  className="customerBillAddButton"
                >
                  Add
                </button>
              </div>
            ) : null}

            {isOpen ? (
              <>
                <div>
                  <label>Company Owner Name </label>
                  <input
                    type="text"
                    name="CompOwnerName"
                    value={newCompany.CompOwnerName}
                    onChange={handleNewCompanyChange}
                  />
                </div>
                <div>
                  <label>Company Registered Address</label>
                  <input
                    type="text"
                    name="CompRegisteredAddress"
                    value={newCompany.CompRegisteredAddress}
                    onChange={handleNewCompanyChange}
                  />
                </div>
                <div>
                  <label>Company Factory Address</label>
                  <input
                    type="text"
                    name="CompFactoryAddress"
                    value={newCompany.CompFactoryAddress}
                    onChange={handleNewCompanyChange}
                  />
                </div>

                <div>
                  <label>Company Phone No</label>
                  <input
                    name="CompPhoneNo"
                    type="text"
                    value={newCompany.CompPhoneNo}
                    onChange={handleNewCompanyChange}
                  />
                </div>

                <div>
                  <label>Company Registration No</label>
                  <input
                    name="CompRegistrationNo"
                    type="text"
                    value={newCompany.CompRegistrationNo}
                    onChange={handleNewCompanyChange}
                  />
                </div>
                <div>
                  <label>Year Of Establishment</label>
                  <input
                    name="CompYearOfEstablishment"
                    type="text"
                    value={newCompany.CompYearOfEstablishment}
                    onChange={handleNewCompanyChange}
                  />
                </div>
                <div>
                  <label>Company Email</label>
                  <input
                    name="CompEmail"
                    type="text"
                    value={newCompany.CompEmail}
                    onChange={handleNewCompanyChange}
                  />
                </div>
                <div>
                  <label>Company GSTIN No</label>
                  <input
                    type="text"
                    name="CompGSTINNo"
                    value={newCompany.CompGSTINNo}
                    onChange={handleNewCompanyChange}
                  />
                </div>
                <div>
                  <label>Company Pan No</label>
                  <input
                    name="CompPanNo"
                    type="text"
                    value={newCompany.CompPanNo}
                    onChange={handleNewCompanyChange}
                  />
                </div>
                <div>
                  <label>Company Website</label>
                  <input
                    name="CompWebsite"
                    type="text"
                    value={newCompany.CompWebsite}
                    onChange={handleNewCompanyChange}
                  />
                </div>
                <div>
                  <label>Company CGST No</label>
                  <input
                    name="CompCGSTNo"
                    type="text"
                    value={newCompany.CompCGSTNo}
                    onChange={handleNewCompanyChange}
                  />
                </div>
                <div>
                  <div
                    style={{ margin: "0px" }}
                    className="adminPanelLoginFormRegisterBox"
                  >
                    <h5
                      style={{ margin: "0px" }}
                      onClick={() => setIsOpen(!isOpen)}
                    >
                      Show Less
                    </h5>
                  </div>
                  <button
                    type="button"
                    onClick={(e) => addCompany(e)}
                    style={{ marginInline: "0px" }}
                    className="customerBillAddButton"
                  >
                    Add
                  </button>
                </div>
              </>
            ) : null}
            {/* <div>
              <button
                type="button"
                onClick={() => setStep(step + 1)}
                style={{ marginInline: "0px" }}
                className="customerBillAddButton"
              >
                Add
              </button>
            </div> */}
          </form>

          <h4 style={{ textAlign: "left" }}>2. Add Branch</h4>
          <h4 style={{ textAlign: "left" }}>3. Add Bank </h4>
        </div>
      ) : step === 2 ? (
        <div className="adminFirstLoginInnerBox">
          <h4
            className="underline-animate"
            onClick={() => (newCompany.OldEntry ? setStep(step - 1) : null)}
            style={{ textAlign: "left" }}
          >
            1. Add Company
            <FcCheckmark
              className="adminFirstLoginInnerBoxCheckIcon"
              size={"20px"}
            />
          </h4>
          <h4 style={{ textAlign: "left" }}>2. Add Branch</h4>
          <form>
            {/* <div>
              <label>Branch Code</label>
              <input
                style={{ cursor: "not-allowed" }}
                name="BranchCode"
                value={newBranch.BranchCode}
                readOnly
                // onChange={handleNewBankChange}
                type="text"
              />
            </div> */}
            <div>
              <label>
                Company ID <sup>*</sup>
              </label>
              <select
                name="CompId"
                value={newBranch.CompId}
                onChange={handleNewBranchChange}
                type="text"
                required="required"
              >
                {allCompaniesList.map((x) => {
                  return (
                    <>
                      <option value={""}>Select an option</option>;
                      <option value={x.Id}>{x.CompName}</option>;
                    </>
                  );
                })}
              </select>
            </div>

            <div>
              <label>
                Branch Name <sup>*</sup>
              </label>
              <input
                name="BranchName"
                value={newBranch.BranchName}
                onChange={handleNewBranchChange}
                type="text"
                required="required"
              />
            </div>
            <div>
              <label>
                Branch Type <sup>*</sup>
              </label>
              <select
                name="BranchType"
                value={newBranch.BranchType}
                onChange={handleNewBranchChange}
                type="text"
                required="required"
              >
                <option value={""}>Select an option</option>;
                <option value={"Showroom"}>Showroom</option>
                <option value={"Warehouse"}>Warehouse</option>
                <option value={"Exhibition"}>Exhibition</option>
              </select>
            </div>
            <div>
              <label>Branch Head</label>
              <input
                name="BranchHead"
                value={newBranch.BranchHead}
                onChange={handleNewBranchChange}
                type="text"
              />
            </div>
            <div>
              <label>Branch Address</label>
              <input
                name="BranchAddress"
                value={newBranch.BranchAddress}
                onChange={handleNewBranchChange}
                type="text"
              />
            </div>
            <div>
              <label>Phone Number </label>
              <input
                name="PhoneNumber"
                value={newBranch.PhoneNumber}
                onChange={handleNewBranchChange}
                type="text"
              />
            </div>
            <div>
              <label>Mobile Number</label>
              <input
                name="MobileNumber"
                value={newBranch.MobileNumber}
                onChange={handleNewBranchChange}
                type="text"
              />
            </div>
            <div>
              <label>Fax Number</label>
              <input
                name="FaxNumber"
                value={newBranch.FaxNumber}
                onChange={handleNewBranchChange}
                type="text"
              />
            </div>
            <div>
              <label>
                Country <sup>*</sup>
              </label>
              <input
                name="Country"
                value={newBranch.Country}
                onChange={handleNewBranchChange}
                type="text"
                required="required"
              />
            </div>
            <div>
              <label>Town</label>
              <input
                name="Town"
                value={newBranch.Town}
                onChange={handleNewBranchChange}
                type="text"
              />
            </div>
            <div>
              <label>State</label>
              <input
                name="State"
                value={newBranch.State}
                onChange={handleNewBranchChange}
                type="text"
              />
            </div>
            <div>
              <label>City</label>
              <input
                name="City"
                value={newBranch.City}
                onChange={handleNewBranchChange}
                type="text"
              />
            </div>
            <div>
              <label>Postal Code</label>
              <input
                name="PostalCode"
                value={newBranch.PostalCode}
                onChange={handleNewBranchChange}
                type="text"
              />
            </div>
            <div>
              <label>GSTIN</label>
              <input
                name="GSTIN"
                value={newBranch.GSTIN}
                onChange={handleNewBranchChange}
                type="text"
              />
            </div>
            <div>
              <label>Branch Email ID</label>
              <input
                name="BranchEmailId"
                value={newBranch.BranchEmailId}
                onChange={handleNewBranchChange}
                type="email"
              />
            </div>
            {/* <label>Branch Status</label>
                  <input
                    name="BranchStatus"
                    value={newBranch.BranchStatus}
                    onChange={handleNewBranchChange}
                    type="text"
                  /> */}
            <div>
              <label>Financial Year</label>
              <input
                name="FinancialYear"
                value={newBranch.FinancialYear}
                onChange={handleNewBranchChange}
                type="text"
              />
            </div>

            <div>
              <button
                type="button"
                // onClick={() => setStep(step + 1)}
                onClick={(e) => addBranch(e)}
                style={{ marginInline: "0px" }}
                className="customerBillAddButton"
              >
                Add
              </button>
            </div>
          </form>

          <h4 style={{ textAlign: "left" }}>3. Add Bank </h4>
        </div>
      ) : step === 3 ? (
        <div className="adminFirstLoginInnerBox">
          <h4
            className="underline-animate"
            onClick={() => (newCompany.OldEntry ? setStep(1) : null)}
            style={{ textAlign: "left" }}
          >
            1. Add Company
            <FcCheckmark
              className="adminFirstLoginInnerBoxCheckIcon"
              size={"20px"}
            />
          </h4>
          <h4
            className="underline-animate"
            onClick={() => (newBranch.OldEntry ? setStep(2) : null)}
            style={{ textAlign: "left" }}
          >
            2. Add Branch
            <FcCheckmark
              className="adminFirstLoginInnerBoxCheckIcon"
              size={"20px"}
            />
          </h4>
          <h4 style={{ textAlign: "left" }}>3. Add Bank</h4>
          <form>
            <div>
              <label>
                Bank Name<sup>*</sup>
              </label>
              <input
                name="BankName"
                value={newBank.BankName}
                onChange={handleNewBankChange}
                type="text"
                required="required"
              />
            </div>
            <div>
              <label>
                Account Name<sup>*</sup>
              </label>
              <input
                name="AccountName"
                value={newBank.AccountName}
                onChange={handleNewBankChange}
                type="text"
                required="required"
              />
            </div>
            <div>
              <label>
                Bank Account No<sup>*</sup>
              </label>
              <input
                name="BankAccountNo"
                value={newBank.BankAccountNo}
                onChange={handleNewBankChange}
                type="text"
                required="required"
              />
            </div>
            <div>
              <label>
                Branch Name<sup>*</sup>
              </label>
              <input
                name="BranchName"
                value={newBank.BranchName}
                onChange={handleNewBankChange}
                type="text"
                required="required"
              />
            </div>
            <div>
              <label>Mobile Number</label>
              <input
                name="MobileNumber"
                value={newBank.MobileNumber}
                onChange={handleNewBankChange}
                type="text"
              />
            </div>
            <div>
              <label>
                Account Type<sup>*</sup>
              </label>
              <input
                name="AccountType"
                value={newBank.AccountType}
                onChange={handleNewBankChange}
                type="text"
                required="required"
              />
            </div>
            <div>
              <label>Branch Address</label>
              <input
                name="BranchAddress"
                value={newBank.BranchAddress}
                onChange={handleNewBankChange}
                type="text"
              />
            </div>
            <div>
              <label>
                Ifsc Code<sup>*</sup>
              </label>
              <input
                name="IfscCode"
                value={newBank.IfscCode}
                onChange={handleNewBankChange}
                type="text"
                required="required"
              />
            </div>
            <div>
              <button
                type="button"
                // onClick={() => setStep(step + 1)}
                onClick={(e) => addBank(e)}
                style={{ marginInline: "0px" }}
                className="customerBillAddButton"
              >
                Add
              </button>
            </div>
          </form>
        </div>
      ) : null}
    </div>
  );
}
